export default "data:video/mp2t;base64,ZXhwb3J0IHR5cGUgT3B0aW9uVHlwZSA9IHsgbmFtZTogc3RyaW5nLCB2YWx1ZTogc3RyaW5nIH07Cg=="